(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collections"] && !window.DesignMode) return;
  try {
    
  // If first section && below_header, añadir padding-top para que la sección quede entera seguida al header y no debajo
  const belowHeader = document.querySelector('.below_header');
  var isFirstSection = false;
  var section = document.querySelector('main div.shopify-section');
  if (section.classList.contains('shopify-section-fixed-search-bar')) {
    section = section.nextElementSibling;
  }
  if (section && section.classList.contains('shopify-section-featured-collections')) {
    isFirstSection = true;
  }
  const breakpoint = window.matchMedia('(min-width:769px)');
  if( belowHeader != null && isFirstSection && breakpoint.matches ){
    const headerHeight = ( document.querySelector('#shopify-section-header') != null ) ? document.querySelector('#shopify-section-header' ).offsetHeight : 0;
    belowHeader.style.paddingTop = headerHeight + 'px';
  }

  } catch(e) { console.error(e); }
})();
})();
